import { render, staticRenderFns } from "./MandatesSelector.vue?vue&type=template&id=e87df22c&scoped=true&"
import script from "./MandatesSelector.vue?vue&type=script&lang=js&"
export * from "./MandatesSelector.vue?vue&type=script&lang=js&"
import style0 from "./MandatesSelector.vue?vue&type=style&index=0&id=e87df22c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87df22c",
  null
  
)

export default component.exports